import styled from '@emotion/styled';

import { ReactComponent as CloudBottomLeft } from '../assets/cloud-bottom-left.svg';
import { ReactComponent as CloudBottomRight } from '../assets/cloud-bottom-right.svg';

export const ImageBottomLeft = styled(CloudBottomLeft)<{ bottom?: number }>(({ bottom }) => ({
    position: 'absolute',
    left: 0,
    bottom: bottom,
    zIndex: -1,
}));

export const ImageBottomRight = styled(CloudBottomRight)<{ bottom?: number }>(({ bottom }) => ({
    position: 'absolute',
    right: 0,
    bottom: bottom,
    zIndex: -1,
}));

export interface PathwayCloudBackgroundParams {
    leftCloudBottom?: number;
    rightCloudBottom?: number;
}

export const PathwayCloudBackground = ({
    leftCloudBottom = 0,
    rightCloudBottom = 0,
}: PathwayCloudBackgroundParams) => {
    return (
        <>
            <ImageBottomLeft bottom={leftCloudBottom} />
            <ImageBottomRight bottom={rightCloudBottom} />
        </>
    );
};
